import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=2008ef56&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=2008ef56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008ef56",
  null
  
)

export default component.exports